import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Modal, Button } from 'antd';
import { connect } from 'dva';
import React from 'react';

const FormItem = Form.Item;

@connect(({ organisation }) => ({
  current: {}, // for future
  organisationsList: organisation.list,
  loading: organisation.loading,
}))
@Form.create()
class EntityForm extends React.PureComponent {
  state = {
    closeModal: false,
  };

  componentDidMount() {
    this.setBaseInfo();
  }

  componentDidUpdate(prevProps) {
    const { statusOperation } = this.props;
    if (prevProps.statusOperation !== statusOperation && statusOperation === 'success') {
      this.setState({ closeModal: true });
    }
  }

  setBaseInfo = () => {
    const { current, form, mode } = this.props;
    let data = mode === 'add' ? {} : { ...current };

    Object.keys(form.getFieldsValue()).forEach(key => {
      const obj = {};
      obj[key] = data[key] || null;

      // support nested fields
      if (typeof data[key] === 'object') {
        Object.keys(data[key]).forEach(subKey => {
          const subObj = {};
          subObj[`${key}.${subKey}`] = data[key][subKey];
          form.setFieldsValue(subObj);
        });
      }

      form.setFieldsValue(obj);
    });
  };

  handleCancel = e => {
    this.setState({ closeModal: true });
    this.props.afterClose();
  };

  onKeyDown = e => {
    if (e.key === 'Enter') {
      this.handleSave();
    }
  };

  handleSave = e => {
    const { dispatch, current, mode } = this.props;
    if (e) e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        dispatch({
          type: 'organisation/create',
          payload: {
            ...values,
          },
        });
        this.setState({ closeModal: true });
        this.props.afterClose();
      }
    });
  };

  render() {
    const {
      mode,
      current,
      loading,
      hideCancel,
      loadingOperation,
      form: { getFieldDecorator },
    } = this.props;

    if (mode !== 'add' && mode !== 'edit') return null;

    return (
      <Form onSubmit={this.handleSubmit} hideRequiredMark onKeyDown={this.onKeyDown}>
        <Modal
          title={mode === 'add' ? 'Create an organization' : 'Edit Organization'}
          visible={this.state.closeModal ? false : true}
          visible={this.props.showCreateOrg}
          onCancel={this.handleCancel}
          closable={hideCancel ? false : true}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleSave}>
              Save
            </Button>,
          ]}
          okButtonProps={{
            loading: loadingOperation,
          }}
          afterClose={this.props.afterClose}
        >
          <FormItem label="Name">
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                },
              ],
            })(<Input />)}
          </FormItem>
        </Modal>
      </Form>
    );
  }
}

export default EntityForm;
